export const ACCOUNT_STATUS = ['Active', 'Pending', 'Suspended'];
export const ACCOUNT_TIER = ['Free', 'Pro', 'Premium'];
export const ACCOUNT_TYPE = ['Free Trial', 'Paid', 'Complimentary'];
export const SUBSCRIPTION_TERMS = ['Yearly', 'Monthly', 'Other', 'TBD'];
export const ACCOUNT_MEMBERS_LIMIT = 10;
